import { render, staticRenderFns } from "./numberCleaningList.vue?vue&type=template&id=72b5b938&scoped=true"
import script from "./numberCleaningList.vue?vue&type=script&lang=js"
export * from "./numberCleaningList.vue?vue&type=script&lang=js"
import style0 from "./numberCleaningList.vue?vue&type=style&index=0&id=72b5b938&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b5b938",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72b5b938')) {
      api.createRecord('72b5b938', component.options)
    } else {
      api.reload('72b5b938', component.options)
    }
    module.hot.accept("./numberCleaningList.vue?vue&type=template&id=72b5b938&scoped=true", function () {
      api.rerender('72b5b938', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clue/page/numberCleaningList.vue"
export default component.exports